export const defaultSettings = [
    {
        key: 'statisticReports',
        settings: [
            {
                title: 'Evacuation Assistance Registrants',
                description:
                    'This notification is a notice that an occupant has requested Evacuation Assistance.',
                frequency: [
                    {
                        text: 'Daily',
                        value: 1,
                    },
                    {
                        text: 'Weekly',
                        value: 7,
                    },
                    {
                        text: 'Monthly',
                        value: 30,
                    },
                ],
                selectedFrequency: {
                    text: 'Daily',
                    value: 1,
                },
                methods: {
                    email: true,
                    // push: false,
                    // sms: false
                },
                recipients: {
                    roles: ['BUILDING_ADMIN', 'FIRE_SAFETY_DIRECTOR', 'TENANT_ADMIN'],
                    emails: [],
                },
                enabled: true
            },
        ],
    }, {
        key: 'trainingReminders',
        settings: [
            {
                title: 'Training Expired X Days Ago',
                description:
                    "This notification is a reminder that the user's training program expired X days ago.",
                access: ['Building', 'Tenant'],
                frequency: [
                    {
                        text: '7 Days',
                        value: 7,
                    },
                    {
                        text: '14 Days',
                        value: 14,
                    },
                    {
                        text: '30 Days',
                        value: 30,
                    },
                    {
                        text: '45 Days',
                        value: 45,
                    },
                ],
                selectedFrequency: [
                    {
                        text: '7 Days',
                        value: 7,
                    }
                ],
                methods: {
                    email: true,
                    // push: false,
                    // sms: false
                },
                recipients: {
                    roles: ['OCCUPANT'],
                },
                enabled: true,
                isMultiSelect: true
            },
            {
                title: 'Expired Training Status',
                description:
                    "This notification is a reminder that a user's training program has expired.",
                access: ['Building', 'Tenant'],
                methods: {
                    email: true,
                    // push: true,
                    // sms: false
                },
                recipients: {
                    roles: ['OCCUPANT'],
                },
                enabled: true
            },
            {
                title: 'Training Going to Expire',
                description:
                    "This notification is a reminder that a user's training program will expire.",
                access: ['Building', 'Tenant'],
                frequency: [
                    {
                        text: '1 Days',
                        value: 1,
                    },
                    {
                        text: '3 Days',
                        value: 3,
                    },
                    {
                        text: '7 Days',
                        value: 7,
                    },
                    {
                        text: '14 Days',
                        value: 14,
                    },
                    {
                        text: '30 Days',
                        value: 30,
                    },
                    {
                        text: '60 Days',
                        value: 60,
                    },
                    {
                        text: '90 Days',
                        value: 90,
                    },
                ],
                selectedFrequency: {
                    text: '7 Days',
                    value: 7,
                },
                methods: {
                    email: true,
                    // push: false,
                    // sms: false
                },
                recipients: {
                    roles: ['OCCUPANT'],
                },
                enabled: true
            },
        ],
    },
    {
        key: 'teams',
        settings: [
            {
                title: 'Notify User to Accept or Decline Team Position',
                description:
                    'This notification asks a user to accept or decline their Team assignment.',
                access: ['Building', 'Tenant'],
                methods: {
                    email: true,
                },
                recipients: {
                    roles: ['OCCUPANT'],
                },
                enabled: true
            },
            {
                title: 'Send Notice When User Accepts Team Position',
                description:
                    'This notification is a notice that a team member has accepted their Team position.',
                access: ['Building', 'Tenant'],
                methods: {
                    email: true,
                },
                // TEAM_PRIMARY_CONTACT is the team's selected Primary Contact;
                // TEAM_MGMT_RIGHTS is any member whose position has add/remove
                // rights, scoped at send time to their floor or tenant.
                recipients: {
                    roles: ['PROPERTY_ADMIN', 'BUILDING_ADMIN', 'TENANT_ADMIN', 'FIRE_SAFETY_DIRECTOR', 'TEAM_PRIMARY_CONTACT', 'TEAM_MGMT_RIGHTS'],
                    activeRoles: ['PROPERTY_ADMIN', 'BUILDING_ADMIN', 'TENANT_ADMIN', 'FIRE_SAFETY_DIRECTOR'],
                    emails: [],
                },
                enabled: true
            },
            {
                title: 'Send Notice When User Declines Team Position',
                description:
                    'This notification is a notice that a team member has declined their Team assignment.',
                access: ['Building', 'Tenant'],
                methods: {
                    email: true,
                },
                recipients: {
                    roles: ['PROPERTY_ADMIN', 'BUILDING_ADMIN', 'TENANT_ADMIN', 'FIRE_SAFETY_DIRECTOR', 'TEAM_PRIMARY_CONTACT', 'TEAM_MGMT_RIGHTS'],
                    activeRoles: ['PROPERTY_ADMIN', 'BUILDING_ADMIN', 'TENANT_ADMIN', 'FIRE_SAFETY_DIRECTOR'],
                    emails: [],
                },
                enabled: true
            },
            {
                title: 'Send Notice When User Adds Themselves to a Team',
                description:
                    'This notification is a notice that a user has joined a Team.',
                access: ['Building', 'Tenant'],
                methods: {
                    email: true,
                },
                recipients: {
                    roles: ['PROPERTY_ADMIN', 'BUILDING_ADMIN', 'TENANT_ADMIN', 'FIRE_SAFETY_DIRECTOR', 'TEAM_PRIMARY_CONTACT', 'TEAM_MGMT_RIGHTS'],
                    activeRoles: ['PROPERTY_ADMIN', 'BUILDING_ADMIN', 'TENANT_ADMIN', 'FIRE_SAFETY_DIRECTOR'],
                    emails: [],
                },
                enabled: true
            },
            {
                title: 'Send Notice When User Removes Themselves from a Team',
                description:
                    'This notification is a notice that a user has removed themselves from a Team.',
                access: ['Building', 'Tenant'],
                methods: {
                    email: true,
                },
                recipients: {
                    roles: ['PROPERTY_ADMIN', 'BUILDING_ADMIN', 'TENANT_ADMIN', 'FIRE_SAFETY_DIRECTOR', 'TEAM_PRIMARY_CONTACT', 'TEAM_MGMT_RIGHTS'],
                    activeRoles: ['PROPERTY_ADMIN', 'BUILDING_ADMIN', 'TENANT_ADMIN', 'FIRE_SAFETY_DIRECTOR'],
                    emails: [],
                },
                enabled: true
            },
            {
                title: 'Notify User They Have Been Removed From Team',
                description:
                    'This notification is a notice that a team member has been removed from the Team.',
                access: ['Building', 'Tenant'],
                methods: {
                    email: true,
                },
                recipients: {
                    roles: ['OCCUPANT'],
                },
                enabled: true
            },
            {
                title: 'Request Team Members to Report as "Here"',
                description:
                    'This notification is a reminder that the user is on a team required to report as "Here".',
                access: ['Building', 'Tenant'],
                methods: {
                    email: true,
                },
                recipients: {
                    roles: ['OCCUPANT'],
                },
                enabled: true
            },
        ],
    },
    {
        key: 'evacuationAssistance',
        settings: [
            {
                title: 'Evacuation Registration Confirmation',
                description:
                    "This notification is a confirmation that a user's Evacuation Request has been submitted.",
                access: ['Building', 'Tenant'],
                methods: {
                    email: true,
                    // push: false,
                    // sms: false
                },
                recipients: {
                    roles: ['OCCUPANT'],
                },
                enabled: true
            },
            {
                title: 'Evacuation Assistance Renewal',
                description:
                    "This notification is a reminder that user's Evacuation Request will expire.",
                access: ['Building', 'Tenant'],
                frequency: [
                    {
                        text: '1 Days',
                        value: 1,
                    },
                    {
                        text: '3 Days',
                        value: 3,
                    },
                    {
                        text: '7 Days',
                        value: 7,
                    },
                    {
                        text: '14 Days',
                        value: 14,
                    },
                    {
                        text: '30 Days',
                        value: 30,
                    },
                    {
                        text: '60 Days',
                        value: 60,
                    },
                    {
                        text: '90 Days',
                        value: 90,
                    },
                ],
                selectedFrequency: {
                    text: '7 Days',
                    value: 7,
                },
                methods: {
                    email: true,
                    // push: false,
                    // sms: false
                },
                recipients: {
                    roles: ['OCCUPANT'],
                },
                enabled: true
            },
        ],
    },
    {
        key: 'miscellaneous',
        settings: [
            {
                title: 'Estimated Population Updates',
                description:
                    'This notification is a notice  that the estimated population needs to be updated and verified.',
                access: ['Building', 'Tenant'],
                frequency: [
                    {
                        text: 'Annually',
                        value: 365,
                    },
                    {
                        text: 'Bi-Annually',
                        value: 180,
                    },
                    {
                        text: 'Monthly',
                        value: 30,
                    },
                    {
                        text: 'Quarterly',
                        value: 90,
                    },
                ],
                selectedFrequency: {
                    text: 'Bi-Annually',
                    value: 180,
                },
                methods: {
                    email: true,
                    // push: false,
                    // sms: false
                },
                recipients: {
                    roles: ['TENANT_ADMIN'],
                },
                enabled: true
            },
            {
                title: 'Notify When Tenant Admin Accepts/Declines System',
                description:
                    'This notification is a notice that a Tenant Admin has accepted or declined the system acknowledgement.',
                access: ['Building', 'Tenant'],
                methods: {
                    email: true,
                },
                recipients: {
                    roles: ['PROPERTY_ADMIN', 'BUILDING_ADMIN'],
                    emails: [],
                },
                enabled: true
            },
        ],
    },
]

